import { useEditRecruitmentContext } from '../Edit/Contexts/EditRecruitmentContext';
import CreateIdentifyExperienceStep from '../Steps/IdentifyExperienceStep/CreateIdentifyExperienceStep';
import EditIdentifyExperienceStep from '../Steps/IdentifyExperienceStep/EditIdentifyExperienceStep';
import CreateJobAdStep from '../Steps/JobAdStep/CreateJobAdStep';
import EditJobAdStep from '../Steps/JobAdStep/EditJobAdStep';
import CreateJobDetailsStep from '../Steps/JobDetailsStep/CreateJobDetailsStep';
import EditJobDetailsStep from '../Steps/JobDetailsStep/EditJobDetailsStep';
import RequestInformationStep from '../Steps/RequestInformation/RequestInformationStep';
import SelectTestsStep from '../Steps/SelectTests/SelectTestsStep';

export interface StepMapperProps {
    activeStep: number;
    handleNext: () => void;
    handleBack: () => void;
}

export function ModifyRecruitmentStepMapper({ activeStep, handleNext, handleBack }: StepMapperProps) {
    const { includesExperienceCriteria } = useEditRecruitmentContext();

    return (
        <>
            {activeStep === 0 && (
                <EditJobDetailsStep activeStep={activeStep} handleNext={handleNext} handleBack={handleBack} />
            )}
            {activeStep === 1 && (
                <EditJobAdStep
                    activeStep={activeStep}
                    handleNext={includesExperienceCriteria ? handleNext : undefined}
                    handleBack={handleBack}
                />
            )}

            {includesExperienceCriteria && activeStep === 2 && (
                <EditIdentifyExperienceStep activeStep={activeStep} handleBack={handleBack} />
            )}
        </>
    );
}

export function CreateFullRecruitmentStepMapper({ activeStep, handleNext, handleBack }: StepMapperProps) {
    return (
        <>
            {activeStep === 0 && (
                <CreateJobDetailsStep activeStep={activeStep} handleNext={handleNext} handleBack={handleBack} />
            )}
            {activeStep === 1 && (
                <CreateJobAdStep activeStep={activeStep} handleNext={handleNext} handleBack={handleBack} />
            )}
            {activeStep === 2 && (
                <SelectTestsStep activeStep={activeStep} handleNext={handleNext} handleBack={handleBack} />
            )}
            {activeStep === 3 && (
                <RequestInformationStep activeStep={activeStep} handleNext={handleNext} handleBack={handleBack} />
            )}
            {activeStep === 4 && <CreateIdentifyExperienceStep activeStep={activeStep} handleBack={handleBack} />}
        </>
    );
}
